/* eslint-disable */

import { hasRent } from "utils/rent";

export const SIMPLE_MACHINE_DATA_WIDTH = 340;
export const ROCKOLA_DATA_WIDTH = 420;
export const RENTED_MACHINE_DATA_WIDTH = 320;
export const NOTE_WIDTH_RATIO = 1.25;

export const getIndividualEditorDataWidth = (machine = {}) => {
  if (hasRent(machine)) return RENTED_MACHINE_DATA_WIDTH;
  const type = machine?.MachineType?.Type ?? machine?.MachineType ?? machine?.MachineTypeType;
  if (["Pool", "Tejo", "Peluchera"].includes(type)) return SIMPLE_MACHINE_DATA_WIDTH;
  if (type === "Rockola") return ROCKOLA_DATA_WIDTH;
  return null;
};

export const getIndividualEditorSizing = (machine = {}) => {
  const dataWidth = getIndividualEditorDataWidth(machine);
  return dataWidth == null
    ? null
    : { dataWidth, noteWidth: dataWidth * NOTE_WIDTH_RATIO };
};

export const centeredDataBlockStyle = (maxWidth) => ({
  width: "100%",
  maxWidth,
  margin: "0 auto",
  textAlign: "left",
});

export const fullWidthDataRowStyle = (baseStyle = {}) => ({
  ...baseStyle,
  width: "100%",
  justifyContent: "space-between",
});

export const compactNumericInputStyle = {
  width: "clamp(8.5rem, 34%, 11rem)",
  flex: "0 1 auto",
  marginLeft: "auto",
};
